<template>
  <div>
    <h1 :style="{color: color}">{{msg}}</h1>
    <!-- <img src="@/assets/logo.png" /> -->
    <img src="../../assets/logo.png" alt="">
    <el-button type="primary">主要按钮</el-button>
    <moor-button></moor-button>
  </div>

</template>

<script>
import MoorButton from '../button'
export default {
  name: 'moorHelloWorld',
  components:{
    MoorButton
  },
  props: {
    color: {
      type: String,
      default: 'pink'
    },
    msg: {
      type: String,
      default: 'Hello World!'
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">

</style>





// WEBPACK FOOTER //
// src/packages/hello-world/moor-hello-world.vue